export const config = {
  token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vZ2VvdGVscGljYWwuY29tL2JhY2tlbmQvYWRtaW4vdXNlcnMiLCJpYXQiOjE2ODI4NTIxNTgsImV4cCI6MTY4Mjg1NTc1OCwibmJmIjoxNjgyODUyMTU4LCJqdGkiOiJRZVV4c2FMTnk2TzBEQWNFIiwic3ViIjoiNSIsInBydiI6IjIzYmQ1Yzg5NDlmNjAwYWRiMzllNzAxYzQwMDg3MmRiN2E1OTc2ZjcifQ.oPvTr8rI9N1G1gN30VNmJe10h7XfdgnSHpT9ym5MCho"
}
